import { render } from "./IziInput.vue?vue&type=template&id=bb6ffde0&scoped=true"
import script from "./IziInput.vue?vue&type=script&lang=ts"
export * from "./IziInput.vue?vue&type=script&lang=ts"

import "./IziInput.vue?vue&type=style&index=0&id=bb6ffde0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bb6ffde0"

export default script